/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @type ConfigMatrixValueValue
 * Value
 * @export
 */
export type ConfigMatrixValueValue = boolean | number | string;

export function ConfigMatrixValueValueFromJSON(json: any): ConfigMatrixValueValue {
    return ConfigMatrixValueValueFromJSONTyped(json, false);
}

export function ConfigMatrixValueValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigMatrixValueValue {
    if (json == null) {
        return json;
    }
    if (typeof json === 'number') {
        return json;
    }
    if (typeof json === 'string') {
        return json;
    }
    if (typeof json === 'boolean') {
        return json;
    }
    return {} as any;
}

export function ConfigMatrixValueValueToJSON(json: any): any {
    return ConfigMatrixValueValueToJSONTyped(json, false);
}

export function ConfigMatrixValueValueToJSONTyped(value?: ConfigMatrixValueValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    return {};
}

